import { render, staticRenderFns } from "./ReviewReturnForm.vue?vue&type=template&id=006c59fc&scoped=true&"
import script from "./ReviewReturnForm.vue?vue&type=script&lang=js&"
export * from "./ReviewReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c59fc",
  null
  
)

export default component.exports